module.exports = __webpack_public_path__ + "static/img/qmwallet1-price.1248c6cf.png";